// extracted by mini-css-extract-plugin
module.exports = {"detailsContainer":"CarSpec_detailsContainer__3OWbO","scooter":"CarSpec_scooter__1pzVF","icon":"CarSpec_icon__1FAY8","detailLabel":"CarSpec_detailLabel__2kN5n"};